var map = {
	"./customers/content/e-seminar.webp": 1367,
	"./customers/content/helal-ahmar.webp": 1368,
	"./customers/content/ikco.webp": 1369,
	"./customers/content/mapna.webp": 1370,
	"./customers/content/milli-1.webp": 1371,
	"./customers/content/milli.webp": 1372,
	"./customers/content/solico.webp": 1373,
	"./customers/e-seminar.png": 1591,
	"./customers/helal-ahmar.png": 1592,
	"./customers/ikco.png": 1593,
	"./customers/mapna.png": 1594,
	"./customers/milli-gold.png": 1595,
	"./customers/solico.png": 1596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2410;